import { render } from "./POReceiving.vue?vue&type=template&id=c3f1e7a8"
import script from "./POReceiving.vue?vue&type=script&lang=js"
export * from "./POReceiving.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__